import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const TAB_SEEN_KEY = "xpattern.adminTabSeen";
export const SEEN_EVENT = "xpattern:adminSeen";
const readSeen = () => { try { return JSON.parse(localStorage.getItem(TAB_SEEN_KEY) || "{}"); } catch { return {}; } };

// Owner toolbar badge: how many things appeared since each dashboard tab was last on screen (same rule as the tab pills).
export const useAdminNew = (enabled) => {
  const [times, setTimes] = useState(null);
  const [seen, setSeen] = useState(readSeen);
  useEffect(() => {
    if (!enabled) return;
    let stop = false;
    const load = () => Promise.all([api.adminCustomers().catch(() => []), api.adminDemos().catch(() => []), api.adminRequests().catch(() => []), api.adminSystem(7).catch(() => null)])
      .then(([cs, dm, rq, sys]) => { if (!stop) setTimes({
        trials: [...cs.map((c) => c.created_at || ""), ...dm.map((d) => d.created_at || "")],
        requests: rq.filter((r) => r.status !== "done").map((r) => r.updated_at || r.created_at || ""),
        fleet: [...((sys?.groups || []).filter((g) => !g.resolved).map((g) => g.last || "")), ...(sys?.site_down && sys.incident?.at ? [sys.incident.at] : [])],
      }); });
    load();
    const t = setInterval(() => { if (document.visibilityState === "visible") load(); }, 60000);
    const onSeen = () => setSeen(readSeen());
    window.addEventListener("focus", load); window.addEventListener(SEEN_EVENT, onSeen);
    return () => { stop = true; clearInterval(t); window.removeEventListener("focus", load); window.removeEventListener(SEEN_EVENT, onSeen); };
  }, [enabled]);
  if (!times) return 0;
  return Object.entries(times).reduce((n, [tab, ts]) => n + ts.filter((t) => t && t > (seen[tab] || "1970-01-01")).length, 0);
};
